import api from './api';

export const authService = {
  // Logowanie
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  // Rejestracja
  register: async (username, email, password) => {
    const response = await api.post('/auth/register', { username, email, password });
    return response.data;
  },

  // Pobierz dane aktualnego użytkownika
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Aktualizuj profil
  updateProfile: async (profileData) => {
    const response = await api.put('/auth/profile', profileData);
    return response.data;
  },

  // Zmień hasło
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  // Wylogowanie
  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  // Upload awatara
  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    const response = await api.post('/auth/avatar', formData);
    return response.data;
  },

  // Usuń awatar
  deleteAvatar: async () => {
    const response = await api.delete('/auth/avatar');
    return response.data;
  },

  // Zaloguj się jako inny użytkownik (tylko super admin)
  impersonate: async (userId) => {
    const response = await api.post(`/auth/impersonate/${userId}`);
    return response.data;
  }
};
